import request from '@/utils/http'
import { decodeUrl } from '@/utils/urlMapper'

// 查询热门文章话题
export const getHotTopic = () => {
  return request({
    url: decodeUrl('hotTopic'),
    method: 'get'
  })
}

// 查询文章话题类型列表
export const listTopicType = () => {
  return request({
    url: decodeUrl('topicType'),
    method: 'get'
  })
}

// 查询学科领域列表
export const listDisciplinaryField = () => {
  return request({
    url: decodeUrl('disciplinaryField'),
    method: 'get'
  })
}

// 分页查询开放取用文章列表
export const listArticlePage = (data) => {
  return request({
    url: decodeUrl('articlePage'),
    method: 'post',
    data
  })
}

// 添加文章点击记录
export const addReport = (data) => {
  return request({
    url: decodeUrl('addReportArticle'),
    method: 'post',
    data
  })
}

// 添加文章下载记录
export const addDownloadReport = (data) => {
  return request({
    url: decodeUrl('addDownloadReportArticle'),
    method: 'post',
    data
  })
}

// 查询文章详情
export const getArticleDetail = (articleId) => {
  return request({
    url: decodeUrl('articleDetail'),
    method: 'get',
    params: { articleId }
  })
}

// 查询相关文章
export const listRelatedArticle = (articleId) => {
  return request({
    url: decodeUrl('relatedArticle'),
    method: 'get',
    params: { articleId }
  })
}

// 拼接文章 PDF 在线预览地址（同 getImage 思路，直接交给浏览器内置 PDF 阅读器打开）
export const getArticlePdfUrl = (resource) => {
  if (!resource) return ''
  const base = process.env.VUE_APP_BASE_API || '/api'
  return `${base}${decodeUrl('articlePdf')}?resource=${encodeURIComponent(resource)}`
}
